import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import BroadcastsListToolbar from "../broadcasts/BroadcastsListToolbar";
import BroadcastsListItem from "../broadcasts/BroadcastsListItem";
import { reportingGoals } from "../../src/reportingGoals";
import { observeStickyOptionsShadow } from "../../utils/stickyOptionsColumn";

const BroadcastsList = (props) => {
  const currentSortMetric = props.sort_by || "created_at_latest";
  const goals = reportingGoals(props.website);
  const rowScroller = useRef(null);

  const applyMetricSort = (metric) => {
    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set("sort_by", metric);
    nextUrl.searchParams.delete("page");
    window.location.assign(nextUrl.toString());
  };

  const renderSortableHeading = (label, metric) => (
    <p
      className="broadcasts-list-row-heading text-xl"
      onClick={() => applyMetricSort(metric)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          applyMetricSort(metric);
        }
      }}
      role="button"
      tabIndex={0}
      style={{
        color: "#000000",
        cursor: "pointer",
        fontWeight: 400,
      }}
    >
      {label}
      {currentSortMetric === metric ? " ↓" : ""}
    </p>
  );

  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  }, []);

  useEffect(() => observeStickyOptionsShadow(rowScroller.current), []);

  return (
    <React.Fragment>
      <div className="row hard-center BroadcastsList smooth">
        <div className="col-xs-12 no-padding-sides">
          <BroadcastsListToolbar {...props} />
        </div>
        <div className="col-xs-12 smooth">
          <div
            ref={rowScroller}
            className="row hard-center broadcasts-list-row-container some-vertical-space border-solid border-[1px] border-slate-200 rounded-xl shadow-sm overflow-x-auto"
            style={{ scrollbarWidth: "thin" }}
          >
            <div className="broadcasts-list-row-content">
              <div
                className="col-xs-12 broadcasts-list-row-header"
                style={{
                  position: "sticky",
                  top: "5px",
                  paddingTop: "15px",
                  zIndex: 15,
                  marginTop: 0,
                  background: "#fff",
                }}
              >
                <div className="broadcasts-list-name-column">
                  <p className="broadcasts-list-row-heading">Name</p>
                </div>
                <div className="broadcasts-list-metrics">
                  <div className="broadcasts-list-metric">
                    <p className="broadcasts-list-row-heading">Campaigns</p>
                  </div>
                  <div className="broadcasts-list-metric broadcasts-list-metric-wide">
                    {renderSortableHeading("Views", "views")}
                  </div>
                  <div className="broadcasts-list-metric broadcasts-list-metric-wide">
                    {renderSortableHeading("Conversions", "conversions")}
                  </div>
                  {goals.checkouts && (
                    <div className="broadcasts-list-metric">
                      {renderSortableHeading("Revenue", "revenue")}
                    </div>
                  )}
                  {goals.bookings && (
                    <div className="broadcasts-list-metric">
                      {renderSortableHeading("Bookings", "bookings")}
                    </div>
                  )}
                  {goals.custom && (
                    <div className="broadcasts-list-metric">
                      {renderSortableHeading(
                        goals.customGoalLabel,
                        "custom_goals"
                      )}
                    </div>
                  )}
                  <div className="broadcasts-list-status-column">
                    <p className="broadcasts-list-row-heading">Status</p>
                  </div>
                  <div className="broadcasts-list-options-column sticky-options-col"></div>
                </div>
              </div>
              <div className="col-xs-12">
                {props.broadcasts.map((broadcast) => {
                  return (
                    <BroadcastsListItem
                      key={"broadcast-" + broadcast.id}
                      broadcast={broadcast}
                      {...props}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BroadcastsList;
